import { Card, CardContent } from "@/components/ui/card";
import QuotationForm from "@/v2/components/pages/quotation/Form";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { ScrollTextIcon } from "lucide-react";
import { useParams } from "react-router-dom";

export default function EditQuotation() {
    const { id } = useParams();
    return (
        <div className="my-3 min-h-screen">
            <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
                <FormPageHeading
                    title={"Edit Quotation"}
                    description="Enter information to update quotation"
                    Icon={ScrollTextIcon}
                />

                <CardContent className="pt-6">
                    <QuotationForm id={id} />
                </CardContent>
            </Card>
        </div>
    );
}
